export const PLAN_YEARLY = 'yearly'
export const PLAN_MONTHLY = 'monthly'

export const DEFAULT_PLAN_KEY = PLAN_YEARLY

// Display-only metadata. Prices come from the BE `plans` payload at runtime; PLANS is the legacy fallback.
export const PLAN_META = {
  [PLAN_YEARLY]: {
    cadence: 'month',
    renewalIntervalMonths: 1,
    badge: 'save_60',
    subtitle: 'billed_monthly',
  },
  [PLAN_MONTHLY]: {
    cadence: 'month',
    renewalIntervalMonths: 1,
    badge: 'cancel_anytime',
    subtitle: 'no_commitment',
  },
}

export const PLANS = [
  {
    key: PLAN_YEARLY,
    price: 9.99,
    originalPrice: 24.99,
    ...PLAN_META[PLAN_YEARLY],
  },
  {
    key: PLAN_MONTHLY,
    price: 24.99,
    originalPrice: null,
    ...PLAN_META[PLAN_MONTHLY],
  },
]

export function findPlan(planKey) {
  return PLANS.find((plan) => plan.key === planKey) || PLANS[0]
}

// BE i18n returns the same originalPrice for both plans; suppress when equal to live price
// so the strikethrough doesn't render the same value (reads as a broken discount).
function effectiveOriginalPrice(rawOriginal, currentPrice) {
  if (rawOriginal == null) return null
  const parsed = parseFloat(String(rawOriginal).replace(/[^0-9.]/g, ''))
  if (Number.isNaN(parsed)) return rawOriginal
  return parsed === currentPrice ? null : rawOriginal
}

export function buildPlansFromBackend(bePlans) {
  if (!Array.isArray(bePlans) || bePlans.length === 0) return PLANS

  return bePlans.map((bePlan) => {
    const meta = PLAN_META[bePlan.planType] || PLAN_META[PLAN_YEARLY]
    const summary = bePlan.orderSummary || {}
    return {
      key: bePlan.planType,
      price: summary.currentPrice,
      pricePerModel: summary.pricePerModel,
      originalPrice: effectiveOriginalPrice(summary.originalPrice, summary.currentPrice),
      vatAmount: summary.vatAmount ?? 0,
      paymentIntent: bePlan.paymentIntent,
      signature: bePlan.signature,
      isDefault: Boolean(bePlan.isDefault),
      ...meta,
    }
  })
}
